// dependencies
import { Map } from "immutable";

const initialState = Map({
	templates: Map(),
});

const permissionsReducer = (state = initialState, action) => {
	switch (action.type) {
		case "REVIEWCYCLES:GETTEMPLATE@SUCCESS": {
			const template = action.response.getIn(["reviewTemplate"], null);
			const templateID = action.response.getIn(["reviewTemplate", "id"], null);

			return state.setIn(["templates", templateID], template);
		}

		default: {
			return state;
		}
	}
};

export default permissionsReducer;
